module.exports = __webpack_public_path__ + "static/media/logo_bby.4abc705d.svg";